import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import {
  Box,
  Container
} from '@material-ui/core';

import ExpenseListResults from 'components/Expenses/ExpenseListResults';

const mapStateToProps = (state) => ({
  activeUserId: state.activeUserId,
  activeUserType: state.activeUserType,
  employees: state.employees,
  vendors: state.vendors,
  expenses: state.expenses,
  //expenseTypes: state.expenseTypes,
  //fundTransfers: state.fundTransfers,
  idGen: state.idGen,
  user: state.user
});

const ExpenseList = (props) => (
  <>
    <Helmet>
      <title>Expenses | Duot Khayat</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container maxWidth={false}>
        <ExpenseListResults
          activeUserId={props.activeUserId}
          activeUserType={props.activeUserType}
          employees={props.employees}
          vendors={props.vendors}
          expenses={props.expenses}
          //expenseTypes={props.expenseTypes}
          //fundTransfers={props.fundTransfers}
          idGen={props.idGen}
          user={props.user}
        />
      </Container>
    </Box>
  </>
);

export default connect (mapStateToProps) (ExpenseList);
